module.exports = __webpack_public_path__ + "static/media/renshizhuanyuan1.36cc3abf.png";